module.exports = __webpack_public_path__ + "static/media/sailec-medium.1e2837b2.woff";